import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

/* --- Main --- */
import { MainPage } from "./pages/MainPage/main/MainPage";

/* --- Board (게시판: 공지, FAQ, 갤러리) --- */
import { Notice } from "./pages/board/notice/notice";
import { NoticeWrite } from "./pages/board/notice/NoticeWrite.jsx";
import { Gallery } from "./pages/board/gallery/gallery";
import { GalleryDetail } from "./pages/board/gallery/GalleryDetail.jsx";
import { NoticeDetail } from './pages/board/notice/NoticeDetail';
import { NoticeEdit } from './pages/board/notice/NoticeEdit';

import { GalleryEdit } from "./pages/board/gallery/GalleryEdit.jsx";
import { GalleryWrite } from "./pages/board/gallery/GalleryWrite"; 

/* --- Admin --- */
import { AdLogin } from "./pages/admin/login/adLogin";

/* --- Social --- */
import { Instagram } from "./pages/social/instagram/instagram.jsx";
import { Blog } from "./pages/social/blog/blog.jsx";
import { Youtube } from "./pages/social/youtube/youtube.jsx";

/* --- Service (서비스) --- */
import { Meal } from "./pages/service/meal/meal";
import { MealWrite } from "./pages/service/meal/MealWrite";
import { Recreation } from "./pages/service/recreation/recreation";
import { RecreationWrite } from "./pages/service/recreation/RecreationWrite";
import { Admission } from "./pages/service/admission/admission";
import { Charge } from "./pages/service/charge/charge";
import { Procedure } from "./pages/service/procedure/procedure";
import { Volunteer } from "./pages/service/volunteer/volunteer";

/* --- Center (센터 소개) --- */
import { Intro } from "./pages/center/intro/intro";
import { Map } from "./pages/center/map/map";
import { Vision } from "./pages/center/vision/vision";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainPage />} />

        {/* --- Board --- */}
        <Route path="/notice" element={<Notice />} />
        <Route path="/notice/noticewrite" element={<NoticeWrite />} />
        <Route path="/notice/:id" element={<NoticeDetail />} />
        <Route path="/notice/noticeedit/:id" element={<NoticeEdit />} />
        
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/gallery/Gallerydetail/:id" element={<GalleryDetail />} />
        <Route path="/gallery/Gallerywrite" element={<GalleryWrite />} />
        <Route path="/gallery/Galleryedit/:id" element={<GalleryEdit />} />

        {/* --- Admin --- */}
        <Route path="/adLogin" element={<AdLogin />} />

        {/* --- Social --- */ }
        <Route path="/instagram" element={<Instagram />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/youtube" element={<Youtube />} />

        {/* --- Service --- */}
        <Route path="/meal" element={<Meal />} />
        <Route path="/meal/MealWrite" element={<MealWrite />} />
        <Route path="/recreation" element={<Recreation />} />
        <Route path="/recreation/RecreationWrite" element={<RecreationWrite />} />
        <Route path="/admission" element={<Admission />} />
        <Route path="/volunteer" element={<Volunteer />} />
        <Route path="/procedure" element={<Procedure />} />
        <Route path="/charge" element={<Charge />} />

        {/* --- Center --- */}
        <Route path="/intro" element={<Intro />} />
        <Route path="/map" element={<Map />} />
        <Route path="/vision" element={<Vision />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;